import { Link } from "react-router-dom";
import { Input, Label } from "reactstrap";
import { Btn, H6, P } from "../../../../AbstractElements";
import ActiveOrderUserDetails from "./ActiveOrderUserDetails";
import { activeOrderTableBody } from "../../../../Data/Dashboard/CryptoDashboard/CryptoDashboard";

const ActiveOrderTableBody = () => {
  return (
    <tbody>
      {activeOrderTableBody.map((data, i) => (
        <tr key={i}>
          <td>
            <div className="form-check">
              <Input type="checkbox" />
              <Label className="form-check-label" />
            </div>
          </td>
          <td>
            <div className="d-flex">
              <div className="flex-grow-1">
                <Link to={`${process.env.PUBLIC_URL}/ecommerce/paymentdetails`}>
                  <H6 className="f-w-600">{data.date}</H6>
                  <span>{data.time}</span>
                </Link>
              </div>
            </div>
          </td>
          <td>
            <Btn className="type" color="transparent">{data.button}</Btn>
          </td>
          <td>
            <ActiveOrderUserDetails data={data} />
          </td>
          <td>{data.price}</td>
          <td>{data.usd}</td>
          <td>
            <div className="order">
              <P>{data.status}</P>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default ActiveOrderTableBody;
